import { service_types } from "../reducers/cart";

export const SET_PAGE_COUNT = "SET_PAGE_COUNT";
export const SET_SERVICE_CATEGORY = "SET_SERVICE_CATEGORY";
export const ADD_TO_CART = "ADD_TO_CART";
export const CLEAR_CART = "CLEAR_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REMOVE_EXTRAS_FROM_CART = "REMOVE_EXTRAS_FROM_CART";
export const CHANGE_CART_ITEM = "CHANGE_CART_ITEM";
export const SET_ENTIRE_CART = "SET_ENTIRE_CART";
export const SET_REVIEW = "SET_REVIEW";
export const CLEAR_REVIEW = "CLEAR_REVIEW";
export const CHANGE_LOCALE = "CHANGE_LANG";

//SERVICES
export const GET_ALL_SERVICES = "GET_ALL_SERVICES";
export type extra_service = {
  duration: number;
  name: string;
  id: number;
  price: number;
  discount: number | null;
  extra_max_quantity?: number;
  photo_path: string | null;
};

export type extra_service_ext = extra_service & {
  price_with_discount: number;
  parent_id: number;
  extra: true;
};

type base_service = {
  id: number;
  parent_id: undefined;
  included_label: string;
  name: string;
  description: string;
  price: number;
  price_with_discount: number;
  discount: number | null;
  deposit: number;
  duration: number;
  reviews_count: number | null;
  photo_path: string | null;
  position: number;
  category_id: number;
  extra_max_quantity?: number;
  categories: {
    id: number;
    name: string;
  }[];
  extra_services: extra_service[];
  included_services: {
    id: number;
    name: string;
    service_id: number;
  }[];
  before_after_images?: {
    id: number;
    image: string;
  }[];
  videos?: string[];
};

export type service =
  | (base_service & {
      type: "gift" | "typical";
    })
  | (base_service & {
      type: "custom_url";
      url: string;
      button_label: string;
    })
  | (base_service & {
      type: "gift";
      gift_values: {
        id: number;
        service_id: number;
        value: number;
      }[];
    });

//CATEGORIES
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export type category = {
  id: number;
  name: string;
  url: string | null;
  position: number | null;
  created_at: string;
  updated_at: string;
};

//ORDER
export const SET_ORDER_DETAILS = "SET_ORDER_DETAILS";
export const CLEAR_ORDER_DETAILS = "CLEAR_ORDER_DETAILS";
export const SET_ORDER_INFO = "SET_ORDER_INFO";
export const SET_PAYMENT_SUCCESS = "PAYMENT_SUCCESSFUL";
export const DIRECT_PAYMENT = "DIRECT_PAYMENT";
export const SET_CART_TOTAL = "SET_CART_TOTAL";
export const SET_CHECKOUT_ERROR = "SET_CHECKOUT_ERROR";
export const SET_ADDRESS_BLACKLISTED = "SET_ADDRESS_BLACKLISTED";
export const SET_EMAIL_BLACKLISTED = "SET_EMAIL_BLACKLISTED";
export const SET_TIME_ERROR = "SET_TIME_ERROR";
export const SET_COUPON = "SET_COUPON";

export type order = {
  order: {
    id: number;
    services: {
      id: number;
      name: string;
      category: string;
      quantity: number;
      price: number;
      price_with_discount: number;
      discount: number;
      duration: number;
      photo_path: string | null;
    }[];
    status: "pending" | "confirmed" | "ongoing" | "reserved";
    time_start: string;
    time_end: string;
    info: string;
    is_created_by_cleaner: boolean | null;
    notify_on_update: boolean;
    cleaner_id: number;
    cleaner: {
      id: number;
      firstname: string;
      lastname: string;
      email: string;
      mobile: string /* Phone number */;
      address: string;
      bg_color: string;
    };
    client_id: number;
    customer: {
      id: number;
      firstname: string;
      lastname: string;
      type_id: number;
      mobile: string;
      address: string;
      longitude: number;
      latitude: number;
      email: string;
      info: string | null;
      source_id: number;
      marketing_agreed: boolean;
      created_at: string /* Date */;
      updated_at: string /* Date */;
    };
    type: string | null;
    source: string | null;
    full_payment: boolean;
    reschedule_token: string;
  };
  client_secret: string;
  payment_required: boolean;
};

type Merge<A extends object, B extends object> = {
  [K in keyof A | keyof B]: K extends keyof A
    ? A[K]
    : K extends keyof B
    ? B[K]
    : never;
};

export type orderDetailsType = {
  data: Merge<
    order["order"],
    {
      extra_services?: {
        parent_id: number;
        id: number;
        name: string;
        category: string;
        quantity: number;
        price: number;
        discount: number;
        duration: number;
        photo_path: string;
      }[];
      gift_values?: {
        quantity: number;
        id: number;
        value: number;
        service: {
          id: number;
          name: string;
          description: string | null;
          price: number;
          discount: number;
          deposit: number;
          duration: number;
          photo_path: string | null;
          position: number;
          min_order: number | null;
          type: "gift";
          extra_services: [];
          reviews_count: number;
          price_with_discount: number;
          categories: {
            id: number;
            name: string;
            url: string | null;
          }[];
          included_services: [];
          gift_values: {
            id: number;
            service_id: number;
            value: number;
          }[];
        };
      }[];
      reschedule_token: string;
      client_secret: string;
      "coupon code": string | null;
      full_payment: number; // 1 is true, 0 is false
      random_cleaner: number; // 1 is true, 0 is false
    }
  >;
};

//EMPTY
export const EMPTY = "EMPTY";

//CLEANERS
export type cleaner = {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  mobile: string;
  address: string;
  bg_color: string;
};
export type cleanBusyInterval = {
  start_time: string;
  end_time: string;
};

/*
  Example {
    start_work_at: "09:00",
    end_work_at: "09:00"
  };
*/
export type workSchedule = {
  time: number;
  free: boolean;
};

export type timeCell = {
  time: string;
  available: boolean;
};

export type reviewObj = {
  id: number;
  rate: number;
  comment: string | null;
  customer: order["order"]["customer"];
  services: null | { id: number; name: string };
  extraServices: null | { id: number; name: string };
  created_at: string;
};
export type reviews = { data: reviewObj[] };

// SETTINGS
export const SET_SYSTEM_SETTINGS = "SET_SYSTEM_SERVICES";
export type settings = {
  order_reschedule_interval: number;
  order_creation_before_interval: number;
  minimum_order: number;
};
